import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@heroui/react'

export default function BatchReviewModal(
  {
    isOpen,
    onOpenChange,
    recipients_count,
    global,
    cleanedMappings,
    onConfirm,
    onCancel,
  },
) {
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      onClose={onCancel}
      radius="sm"
      classNames={{
        footer: 'bg-gray-50',
        body: 'flex flex-col gap-5 w-full p-4 bg-gray-50',
        header: 'border-b border-gray-200 bg-[#18181b] w-full',
      }}
    >
      <ModalContent>
        <ModalHeader className="flex flex-col gap-1">
          <h2 className={`
            flex items-center gap-3 font-taurus text-2xl font-semibold
            text-white
          `}
          >
            Ready to send
            {' '}
            {recipients_count || 0}
            {' '}
            calls?
          </h2>
          <p className={`
            font-taurus text-xs font-light tracking-wider text-foreground-400
          `}
          >
            Review your configuration below before sending.
          </p>
        </ModalHeader>
        <ModalBody>
          <pre>
            <span className="text-foreground-400">Global</span>
            <br />
            {Object.entries(global ?? {}).map(([key, value]) => (
              <span key={key} className="flex gap-x-1">
                <span className="text-primary">{key}</span>
                :
                {
                  typeof value === 'object'
                    ? JSON.stringify(value)
                    : <span className="text-success">{String(value)}</span>
                }
                <br />
              </span>
            ))}
            {Object.keys(cleanedMappings ?? {}).length > 0 && (
              <>
                <br />
                <span className="text-foreground-400">Mappings</span>
                <br />
                {Object.entries(cleanedMappings ?? {}).map(([key, value]) => (
                  <span key={key} className="flex gap-x-1">
                    <span className="text-primary">{value}</span>
                    :
                    <span className="text-success">{String(key)}</span>
                    <br />
                  </span>
                ))}
              </>
            )}
          </pre>
        </ModalBody>
        <ModalFooter className="flex gap-2">
          <Button
            color="danger"
            variant="light"
            radius="sm"
            onPress={onCancel}
            className="flex-1"
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="solid"
            radius="sm"
            onPress={onConfirm}
            className="flex-1"
          >
            Looks good!
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}
